import { formatDate } from '@angular/common';
import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class DateConverter implements JsonCustomConvert<Date | null> {
  public serialize(date: Date | null): string | null {
    if (date instanceof Date) {
      return formatDate(date, 'yyyy-MM-dd', 'fr');
    } else {
      return null;
    }
  }

  public deserialize(date: string): Date | null {
    if (date === null || date === '') {
      return null;
    }
    return new Date(date);
  }
}
